import React, { Component } from "react";
import { formValueSelector } from "redux-form";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import ExportsForm from "./ExportsForm";
import exportPageTypes from "./enums/exportPageTypes";
import { isClientInTransition } from "../../../common/RouteValidators/ClientValidationHelper";
class ExportsPage extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      message: null,
      showTransitionWarning: false
    };
    this.handleMessage = this.handleMessage.bind(this);
    this.setShowTransitionWarning = this.setShowTransitionWarning.bind(this);
    this.refetchIsTransition = this.refetchIsTransition.bind(this);
  }
  handleMessage(message) {
    this.setState({ message: message });
  }

  setShowTransitionWarning(value) {
    this.setState({showTransitionWarning: value});
  }

  refetchIsTransition() {
    if(this.props.clientId){
      isClientInTransition(this.props.clientId).then((res) => {
        /** Response is either true or false. */
        this.setShowTransitionWarning(res);
      });
    }
  }
  render() {
    const exportPages = exportPageTypes.filter((page) => {
      if (page.condition && page.condition() === false) {
        return false;
      } else {
        return {
          key: page.key,
          value: page.value,
        };
      }
    });
    const exportPage = exportPageTypes.find(
      (page) => page.value === this.props.exportType
    );
    return (
      <div className="sub-container">
        <div className="sub-content">
          <div className="standalone-form import-export">
            {this.state.message}
            <ExportsForm refetchIsTransition={this.refetchIsTransition} showTransitionWarning={this.state.showTransitionWarning} options={exportPages} />
            {exportPage && (
              <exportPage.component setShowTransitionWarning={this.setShowTransitionWarning} onUpdate={this.handleMessage} />
            )}
          </div>
        </div>
      </div>
    );
  }
}
ExportsPage.propTypes = {
  exportType: PropTypes.string,
  clientId: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.number,
  ])
};
function mapStateToProps(state) {
  const selector = formValueSelector("exportsForm");
  const exportMembersSelector = formValueSelector("exportMembersForm");

  return {
    exportType: selector(state, "exportType"),
    message: state.message,
    clientId: exportMembersSelector(state, "clientId")
  };
}
export default connect(mapStateToProps, null)(ExportsPage);



// WEBPACK FOOTER //
// ./src/components/dashboard/importExport/exports/ExportsPage.js